module.exports = __webpack_public_path__ + "img/ico-copy.b0b51aac.svg";